import React from 'react';

import {
  Box,
  FormControl,
  InputAdornment,
  MenuItem,
  Select,
  Stack,
  TextField
} from '@mui/material';

import {
  KeyboardArrowDown,
  SearchOutlined
} from '@mui/icons-material';

import CardContentWrapper from './CardContentWrapper';

import CommonTable
  from '../../Common/components/Listing/CommonTable';

import {
  menuProps,
  searchFieldSx,
  textFieldSx
} from '../../Common/components/Styles/InputStyles';

import {
  userColumns
} from '../settingsConfig';

const UserSettings = ({
  search,
  status,
  account,
  rows,
  totalCount,
  page,
  rowsPerPage,
  loading,
  onSearchChange,
  onStatusChange,
  onAccountChange,
  onPageChange,
  onRowsPerPageChange,
  onInvite,
  renderAction
}) => {
  return (
    <CardContentWrapper
      title="View/Manage Providers & Staff"
      count={`${totalCount} Users`}
      buttonText="Add User"
      onInvite={onInvite}>
      <Stack
        direction="row"
        spacing={1}
        sx={{
          mb: 1.5,
          flexWrap: 'wrap'
        }}>
        <TextField
          size="small"
          value={search}
          placeholder="Search users..."
          onChange={onSearchChange}
          sx={{
            ...searchFieldSx,
            width: '25%'
          }}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <SearchOutlined
                    sx={{
                      color: '#9E9E9E',
                      fontSize: 20
                    }}
                  />
                </InputAdornment>
              )
            }
          }}
        />

        <FormControl
          size="small"
          sx={{
            ...textFieldSx,
            width: '21%'
          }}>
          <Select
            size="small"
            value={status}
            onChange={onStatusChange}
            IconComponent={KeyboardArrowDown}
            MenuProps={menuProps}>
            <MenuItem value="All">
              All Status
            </MenuItem>
            <MenuItem value="Active">
              Active
            </MenuItem>
            <MenuItem value="Inactive">
              Inactive
            </MenuItem>
          </Select>
        </FormControl>

        <FormControl
          size="small"
          sx={{
            ...textFieldSx,
            width: '21%'
          }}>
          <Select
            size="small"
            value={account}
            onChange={onAccountChange}
            IconComponent={KeyboardArrowDown}
            MenuProps={menuProps}>
            <MenuItem value="All">
              All Account Types
            </MenuItem>
            <MenuItem value="Provider">
              Provider
            </MenuItem>
            <MenuItem value="Staff">
              Staff
            </MenuItem>
            <MenuItem value="Admin">
              Admin
            </MenuItem>
          </Select>
        </FormControl>
      </Stack>

      {loading ? (
        <Box
          sx={{
            minHeight: 220,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#757575',
            fontSize: 13
          }}>
          Loading users...
        </Box>
      ) : (
        <CommonTable
          columns={userColumns}
          rows={rows}
          totalCount={totalCount}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[
            25,
            50,
            75,
            100
          ]}
          emptyText="No users found."
          actionWrapper={false}
          onPageChange={onPageChange}
          onRowsPerPageChange={
            onRowsPerPageChange
          }
          renderAction={renderAction}
        />
      )}
    </CardContentWrapper>
  );
};

export default UserSettings;